import script from "./SellerFormCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SellerFormCard.vue?vue&type=script&setup=true&lang=js"

import "./SellerFormCard.vue?vue&type=style&index=0&id=45d5dd7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45d5dd7a"]])

export default __exports__